// BannerLine.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BannerLine = ({ message, navigateTo, duration = 5000 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);

  const handleClick = () => {
    navigate(navigateTo);
  };

  // Show and then auto-hide after a set duration, every time the route changes
  useEffect(() => {
    setVisible(true); // Make it visible again on route change

    const timer = setTimeout(() => {
      setVisible(false); // Hide after the duration
    }, duration);

    return () => clearTimeout(timer);
  }, [location.pathname, duration]); // 
  
  // Hide on specific routes no matter what
  const shouldHide =
    location.pathname === '/coursesoffered' || location.pathname === '/instilit-Promo' || !visible;

  if (shouldHide) return null;

  return (
    <div
      className="banner-line w-full px-4 py-3 bg-blue-600 text-white text-center cursor-pointer hover:bg-blue-700 transition"
      onClick={handleClick}
    >
      <span className="text-sm md:text-base">{message}</span>
    </div>
  );
};

export default BannerLine;
